import { render, staticRenderFns } from "./orderConfirmationCheck.vue?vue&type=template&id=ede00d08&scoped=true"
import script from "./orderConfirmationCheck.vue?vue&type=script&lang=js"
export * from "./orderConfirmationCheck.vue?vue&type=script&lang=js"
import style0 from "./orderConfirmationCheck.vue?vue&type=style&index=0&id=ede00d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede00d08",
  null
  
)

export default component.exports